var map = {
	"./2-users-20x20.svg": "dcdc",
	"./add-linear-24x24.svg": "3103",
	"./add-to-cart-mobile-icon.svg": "6ee9",
	"./arrow-left-20x20.svg": "f837",
	"./arrow-right-20x20.svg": "f537",
	"./article-arrow-20x20.svg": "a3bc",
	"./badge-product-page-left-corner.svg": "8a06",
	"./badge-product-page-right-corner.svg": "0278",
	"./breadcrumb-arrow-right-16x16.svg": "28c5",
	"./cake.jpg": "ab1e",
	"./cake.png": "6039",
	"./cake.svg": "6102",
	"./call-bold-20x20.svg": "7de9",
	"./call-phone-20x20.svg": "12cc",
	"./card-checked.svg": "7916",
	"./card-linear.svg": "d3b2",
	"./card-unchecked.svg": "52d6",
	"./caret-right-gray-16x16.svg": "cc28",
	"./carousel-arrow-left-20x20.svg": "0455",
	"./carousel-arrow-right-20x20.svg": "6f06",
	"./carousel-pagination-active.svg": "160b",
	"./carousel-pagination-notactive.svg": "4637",
	"./cart-bold-filled-20x20.svg": "254b",
	"./chevron-left-32x32.svg": "39a5",
	"./chevron-right-20x20-gray.svg": "4598",
	"./chevron-right-20x20-gray_accentuate.svg": "9226",
	"./chevron-right-32x32.svg": "a6c6",
	"./cupcake_20x20.svg": "01d0",
	"./dropdown-toggle-16x16.svg": "aeb6",
	"./dropdown-toggle-20x20.svg": "dc80",
	"./dropdown-toggle.svg": "4b4e",
	"./edit-linear-24x24.svg": "f70a",
	"./email-bold-20x20.svg": "66a1",
	"./empty-star-20x20.svg": "15c9",
	"./eye-linear-20x20.svg": "5be0",
	"./eye-slash-linear-20x20.svg": "ea5d",
	"./facebook-20x20.svg": "a367",
	"./file-download-20x20.svg": "2c59",
	"./filled-star-20x20.svg": "5a8b",
	"./gallery-20x20.svg": "47de",
	"./gmail-20x20.svg": "5d9b",
	"./gray-calendar-linear-20x20.svg": "b1c2",
	"./gray-card-linear-20x20.svg": "bd5d",
	"./gray-chevron-down-20x20.svg": "3672",
	"./gray-chevron-up-20x20.svg": "844c",
	"./gray-dot-4x4.svg": "493a",
	"./gray-fb-icon.svg": "7b9d",
	"./gray-gift-linear-24x24.svg": "f80d",
	"./gray-insta-icon.svg": "502b",
	"./gray-location-linear-20x20.svg": "9a3e",
	"./gray-mail-icon.svg": "8510",
	"./gray-whatsapp-icon.svg": "8942",
	"./heart-empty.svg": "83f3",
	"./heart-filled.svg": "4c8e",
	"./home-category-arrow-24x24.svg": "b4bb",
	"./info-circle-info-20x20.svg": "4a61",
	"./location-bold-20x20.svg": "cd21",
	"./microsoft-20x20.svg": "b1af",
	"./minus-gray-16x16.svg": "ad4d",
	"./mobile-pages/blogs.svg": "5cfd",
	"./mobile-pages/cart-btn.svg": "f520",
	"./mobile-pages/cart.svg": "22db",
	"./mobile-pages/contact.svg": "1e32",
	"./mobile-pages/home-btn.svg": "6c39",
	"./mobile-pages/home.svg": "af7d",
	"./mobile-pages/products.svg": "7591",
	"./mobile-pages/profile-circle-white-20x20.svg": "ab70",
	"./mobile-pages/user-btn.svg": "d154",
	"./moneys-checked.svg": "5962",
	"./moneys-disabled.svg": "cf2c",
	"./moneys-unchecked.svg": "048e",
	"./multiple-products-24x-24.svg": "b414",
	"./order-box-userprofile.svg": "8cf6",
	"./pages/clients.svg": "963d",
	"./pages/employees.svg": "e29c",
	"./pages/holiday-days.svg": "5a93",
	"./pages/holidays-admin.svg": "61ed",
	"./pages/holidays-public.svg": "5045",
	"./pages/holidays.svg": "f96a",
	"./pages/tasks-statuses.svg": "8e0b",
	"./pages/tasks.svg": "4c26",
	"./pages/teams.svg": "dfbc",
	"./pages/templates.svg": "73ab",
	"./pagination/arrows-left.svg": "086e",
	"./pagination/arrows-right.svg": "b5a7",
	"./pagination/chevron-left.svg": "7f5e",
	"./pagination/chevron-right.svg": "3ff7",
	"./pink-call-linear-20x20.svg": "efaf",
	"./pink-cart-bold-20x20.svg": "cdd4",
	"./pink-chevron-down-20x20.svg": "0663",
	"./pink-chevron-up-20x20.svg": "c4ec",
	"./pink-star-bold-24x24.svg": "6b5e",
	"./pink-user-circle-20x20.svg": "8729",
	"./plus-gray-16x16.svg": "f6d4",
	"./profile-circle-linear-24x24.svg": "0102",
	"./profile-circle-linear-40x40.svg": "4498",
	"./reviews-star-userprofile.svg": "f3f3",
	"./rounded-question.svg": "19cc",
	"./search-linear-24x24.svg": "2fa8",
	"./search-normal-20x20.svg": "0dcf",
	"./settings-cog-userprofile.svg": "f943",
	"./shipping-checked.svg": "3c02",
	"./shipping-unchecked.svg": "a865",
	"./shipping.svg": "a6ff",
	"./shop-checked.svg": "3df3",
	"./shop-unchecked.svg": "1ace",
	"./shop.svg": "a631",
	"./star-empty-20x20.svg": "2f54",
	"./star-empty.svg": "6b7b",
	"./star-filled-20x20.svg": "8949",
	"./star-filled.svg": "cdc1",
	"./table-delete-icon.svg": "12f3",
	"./table-edit-20x20.svg": "9253",
	"./table-edit-icon.svg": "bce9",
	"./table-minus-20x20.svg": "d328",
	"./table-plus-20x20.svg": "391f",
	"./table-x-mark-20x20.svg": "ee59",
	"./tag_20x20.svg": "0e75",
	"./tasks/finished.svg": "6629",
	"./tasks/in-progress.svg": "4469",
	"./tasks/not-started.svg": "e746",
	"./tasks/red-warning.svg": "aa6f",
	"./triangle-danger-20x20.svg": "f613",
	"./white-calendar-bold-20x20.svg": "7f17",
	"./white-outline-calendar-20x20.svg": "a8e4",
	"./white-outline-eye-20x20.svg": "44a7",
	"./white-tag-20x20.svg": "f308",
	"./wishlist-heart-userprofile.svg": "8859",
	"./x-clear-icon-40x40.svg": "3afa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0075";